/**
 * WorkTypesPagination
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import ResponsivePagination from '../../../../../../../../components/ResponsivePagination';

// Actions
import { updateQueryString } from '../../../../../../../../services/router/actions';

// Selectors
import { selectDataLength } from '../../selectors';

// Workspaces
import { makeSelectQueryStringNumberValue } from '../../../../../../../../workspaces/react-router-selectors';

interface Props {
    updateQueryString: Function;
    length: number;
    page: number;
    count: number;
}

export class WorkTypesPagination extends React.PureComponent<Props> {
    static defaultProps = {
        length: 0,
        page: 1,
        count: 25
    };

    get totalPages() {
        const { length, count } = this.props;
        return Math.ceil(length / count);
    }

    handlePageChange = (
        event: SyntheticInputEvent<EventTarget>,
        data: { activePage: number }
    ) => {
        this.props.updateQueryString({
            page: data.activePage || undefined
        });

        global.scrollTo(0, 0);
    };

    render() {
        const { page } = this.props;

        if (this.totalPages <= 1 && page === 1) return null;

        return (
            <ResponsivePagination
                activePage={page}
                onPageChange={this.handlePageChange}
                totalPages={this.totalPages}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector({
    page: makeSelectQueryStringNumberValue('page'),
    count: makeSelectQueryStringNumberValue('count'),
    length: selectDataLength
});

export default connect(
    mapStateToProps,
    { updateQueryString }
)(WorkTypesPagination);
